export default __webpack_public_path__ + "static/media/topimgsmall.c9f1fd8b.svg";